export function LoadingSpinner() {
  return (
    <div className="loading text-center py-10 text-text-secondary">
      <div className="spinner w-8 h-8 border-3 border-bg-tertiary border-t-accent rounded-full animate-spin mx-auto mb-4"></div>
      <span>加载中...</span>
    </div>
  );
}
